/**
 * Контент публічного сайту, який правиться з адмінки (вкладка «Контент»).
 *
 * Тут — перелік сторінок і тексти ЗА ЗАМОВЧУВАННЯМ; бекенд
 * (/api/public/site-content) зберігає лише перекриття, тож порожнє поле в
 * адмінці = «як у коді». Сторінки звідси не додаються: перелік фіксований.
 */
import { useEffect, useState } from 'react';
import api from '../../../../api';

export const SITE_PAGES = [
  { path: '/',             label: 'Головна',
    title: 'Trading.com.ua — алготрейдинг акціями США',
    description: 'Робот торгує акціями США на вашому рахунку в Interactive Brokers. Перевірте прибутковість стратегії на історичних даних.' },
  { path: '/returns',      label: 'Дохідність',
    title: 'Дохідність — Trading.com.ua',
    description: 'Перевірте дохідність нашої стратегії на будь-якому періоді від року за історичними даними.' },
  { path: '/guarantees',   label: 'Гарантії',
    title: 'Гарантії — Trading.com.ua',
    description: 'Як захищені ваші кошти: SIPC, Lloyd’s of London, роздільне зберігання в Interactive Brokers.' },
  { path: '/advantages',   label: 'Переваги',
    title: 'Переваги — Trading.com.ua',
    description: 'Кошти доступні будь-коли, у валюті й за кордоном — на вашому власному рахунку.' },
  { path: '/pricing',      label: 'Ціни',
    title: 'Ціни — Trading.com.ua',
    description: 'Безкоштовно на старті, далі — лише відсоток від чистого прибутку раз на три місяці.' },
  { path: '/how-to-start', label: 'Як почати',
    title: 'Як почати — Trading.com.ua',
    description: 'Покроково: рахунок в Interactive Brokers, поповнення і підключення робота.' },
  { path: '/contacts',     label: 'Контакти',
    title: 'Контакти — Trading.com.ua',
    description: 'Зв’яжіться з нами: телефон, Telegram, форма зворотного звʼязку.' },
  { path: '/demo',         label: 'Демо-кабінет',
    title: 'Демо-кабінет — Trading.com.ua',
    description: 'Подивіться, як виглядає кабінет робота з реальними угодами.' },
];

// Підказки «?» калькулятора (ТЗ 29). У тексті підставляються числа з адмінки:
// {fee_tiers} (тарифи сторінки «Ціни» списком), {fee_pct} (діапазон ставок),
// {free_months}, {threshold}, {deposit_fee_pct}, {tax_pct}.
export const CALC_HELP = [
  { key: 'deposit_fee', label: 'Комісія на ввід коштів',
    html: '<p>Якщо у вас немає закордонного рахунку, внести кошти на рахунок Interactive Brokers можна так:</p>'
      + '<ol><li>Поповніть у касі банку готівкою свою валютну картку українського банку.</li>'
      + '<li>З цієї картки перекажіть кошти на свій рахунок у платіжній системі Wise.com, Genome.eu, Transfergo.com або Zen.com.</li>'
      + '<li>З цієї платіжної системи зробіть банківський переказ на рахунок в Interactive Brokers.</li></ol>'
      + '<p>Детальніше — на сторінці «Як почати».</p>'
      + '<p>Сумарні комісії при надсиланні готівкових коштів на рахунок Interactive Brokers складуть близько {deposit_fee_pct}%.</p>' },
  { key: 'taxes', label: 'Податки',
    html: '<p>З інвестиційного прибутку в Україні фізичні особи платять два податки: податок на доходи фізичних осіб (ПДФО) за ставкою 18% та військовий збір за ставкою 5%. Загальне податкове навантаження становить {tax_pct}% від суми чистого прибутку.</p>'
      + '<p>Прибуток — це різниця між грошима від продажу акцій та витратами на їх купівлю. Податок за рік сплачується до 1 серпня наступного року; у розрахунку — 25 липня.</p>' },
  { key: 'trading_fee', label: 'Комісія Trading.com.ua',
    html: '<p>Перші {free_months} місяців і рахунки із сумою до {threshold} $ — безкоштовно.</p>'
      + '<p>Далі — відсоток від приросту рахунку за сезон, залежно від суми на початку сезону:</p>'
      + '{fee_tiers}'
      + '<p>Списується 1-го числа кожного сезону: 1 березня, 1 червня, 1 вересня, 1 грудня.</p>'
      + '<p>Якщо сезон збитковий, комісія не сплачується, доки збиток не буде відіграно: наступні сезони платять лише з приросту понад нього.</p>' },
];

export const CALC_DEFAULTS = {
  trading_fee_pct: 30, trading_fee_threshold: 10000, deposit_fee_pct: 3.5, tax_pct: 23,
  free_months: 6,
};
// trading_fee_pct діє лише без тарифної сітки (бекенд, services/calc_fees.py);
// в адмінці його не показуємо — ставка береться з тарифів блоку «Ціни».

/* Блоки сайту з динамічним текстом (етап 1): загальні числа, контакти, кейси,
   FAQ, футер, ціни. Тут — значення за замовчуванням; бекенд зберігає блок
   цілком лише якщо адмін його змінив (блок, рівний дефолту, не зберігається —
   тоді правка дефолту в коді дійде до сайту). Лише звичайний текст, без HTML:
   React сам екранує, а перенос рядка (\n) показується як новий рядок. */
export const BLOCK_DEFAULTS = {
  general: {
    returns_claim: '45%+',
  },
  contacts: {
    address: 'Україна, м. Рівне, Майдан Незалежності, 3, 33000',
    office_note: 'Графік роботи офісу — у робочі години. За потреби можлива особиста зустріч із керівником проєкту.',
    phone: '+38 (050) 200-60-00',
    telegram: '@trading.com.ua',
    email: 'info@trading.com.ua',
  },
  cases: {
    visible: true,
    badge: 'Кейси клієнтів',
    title: 'Реальні рахунки.\nРеальні цифри.',
    lead: 'Подивіться, як працює алгоритм на рахунках наших клієнтів. Кожен кейс — це реальна історія капіталізації на Interactive Brokers.',
    items: [1, 2, 1].map((n) => ({
      num: String(n),
      title: n === 1 ? 'Масштабування капіталу' : 'Стабільність на волатильному ринку',
      pct: '+34.2%',
      profit: '+3,420 $',
      start: '10,000 $',
      period: '6 місяців',
      name: 'Олександр М.',
      status: 'Верифікований клієнт IBKR',
      quote: 'Найбільше вразило те, що підключення зайняло рівно 15 хвилин через Zoom-консультацію. Я просто згенерував API-ключ, вставив його в кабінет і забув. Тепер раз на тиждень заходжу подивитися на нові закриті угоди в Telegram.',
      date: 'Вересень — Лютий',
    })),
  },
  faq: {
    items: [
      { q: 'Чи може сервіс зняти мої кошти з рахунку Interactive Brokers?',
        a: 'Ні. Ви надаєте алгоритму доступ виключно до виконання торгових операцій через захищений API. У нас немає технічної можливості вивести кошти або переказати їх на інший рахунок — гроші завжди залишаються на вашому особистому рахунку в Interactive Brokers.' },
      { q: 'Яка реальна безпека мого капіталу в США?',
        a: 'Interactive Brokers (NASDAQ: IBKR) — публічна компанія з капіталом понад $12 млрд, діяльність якої регулюють SEC та FINRA. Ваші активи додатково захищені страхуванням SIPC на суму до $500,000. Це один із найвищих стандартів безпеки на світовому ринку.' },
      { q: 'Що станеться, якщо ринок почне стрімко падати?',
        a: 'Алгоритм працює за чіткою системою управління ризиками: автоматично обмежує розмір позицій і фіксує збитки за наперед визначеними рівнями. Стратегія розрахована саме на волатильні ринки — мета не вгадати напрямок, а контролювати ризик у будь-яких умовах.' },
      { q: "Чи потрібно мені тримати комп'ютер увімкненим?",
        a: 'Ні. Алгоритм працює автономно на наших серверах 24/7 і взаємодіє з вашим рахунком напряму через API. Ви можете будь-коли вимкнути комп’ютер чи телефон — торгівля продовжиться без вашої участі.' },
      { q: 'Яка мінімальна сума для старту і чому?',
        a: 'Рекомендований старт — від $10,000. Ця сума дозволяє алгоритму коректно розподіляти капітал між позиціями та дотримуватися правил ризик-менеджменту. З меншим депозитом ефективність диверсифікації знижується.' },
      { q: 'Як працює оподаткування в Україні?',
        a: 'Дохід від інвестицій оподатковується за ставкою 18% ПДФО та 5% військового збору. Декларацію подають самостійно раз на рік за результатами отриманого прибутку. Радимо проконсультуватися з податковим консультантом щодо вашої ситуації.' },
    ],
  },
  footer: {
    tagline: 'Автоматизована торгівля на фондовому ринку США через рахунок IBKR',
    disclaimer_title: 'Попередження про ризики',
    disclaimer: 'Торгівля на фондовому ринку пов\'язана з певним рівнем ризику. Минулі результати алгоритму не є 100%-ою гарантією майбутніх прибутків. Дохідність {returns_claim} є цільовим показником стратегії, проте фактичний результат залежить від ринкової кон\'юнктури. Interactive Brokers LLC є незалежним брокером і не несе відповідальності за роботу нашого алгоритму',
    copyright: '© 2026 Trading.com.ua. Всі права захищені',
    legal: [
      { label: 'Політика конфіденційності', href: '' },
      { label: 'Умови використання', href: '' },
      { label: 'Cookies', href: '' },
    ],
  },
  pricing: {
    free: [
      { prefix: '', value: 6, unit: ' місяців', title: 'Безкоштовно на старті',
        text: 'Перші шість місяців торгуємо безкоштовно — незалежно від суми на рахунку.' },
      { prefix: 'до $', value: 10000, unit: '', title: 'Завжди безкоштовно',
        text: 'Рахунки із сумою до $10 000 ми торгуємо безкоштовно завжди — незалежно від тривалості періоду.' },
    ],
    // from_usd — межа для калькулятора (сума на початку сезону). Має збігатися з
    // DEFAULT_FEE_TIERS у web/backend/services/calc_fees.py.
    tiers: [
      { range: '10–50 тис. $', pct: 15, top: false, from_usd: 10000 },
      { range: '51–100 тис. $', pct: 20, top: false, from_usd: 51000 },
      { range: '101–500 тис. $', pct: 25, top: false, from_usd: 101000 },
      { range: '501–999 тис. $', pct: 30, top: false, from_usd: 501000 },
      { range: '1 млн $+', pct: 35, top: true, from_usd: 1000000 },
    ],
    tiers_note: 'Комісія сплачується від чистого прибутку за квартал — різниці між сумою на початку періоду та сумою через 3 місяці.',
    billing: [
      { title: 'Лише від чистого прибутку',
        text: 'Відсоток береться від різниці між сумою на початку періоду і сумою через 3 місяці.' },
      { title: 'Оплата раз на 3 місяці',
        text: 'Комісія нараховується й сплачується щоквартально — за фактичним результатом.' },
      { title: 'Зручні способи оплати',
        text: 'Готівка, криптовалюта або банківський переказ — на ваш вибір.' },
    ],
    guarantee: [
      { title: 'Імовірність < 1%',
        text: 'На нашу думку, ймовірність такої ситуації менша за 1% — ми проговорюємо її для вашого спокою.' },
      { title: 'Термін — 1 рік',
        text: 'Компенсація через рік від запиту на повернення, щоб ми мали час відіграти нестачу.' },
      { title: 'Нотаріально від $10k',
        text: 'Для сум від $10 000 можливе нотаріальне засвідчення гарантій із повною юридичною силою.' },
    ],
  },
};

let cache = null;
let inflight = null;
const listeners = new Set();

export function loadSiteContent(force = false) {
  if (cache && !force) return Promise.resolve(cache);
  if (inflight && !force) return inflight;
  inflight = api.get('/api/public/site-content', { timeout: 15000 })
    .then((r) => { cache = r.data || {}; listeners.forEach((f) => f(cache)); return cache; })
    .catch(() => { cache = cache || {}; return cache; })
    .finally(() => { inflight = null; });
  return inflight;
}

/** Контент сайту: null, поки не завантажено (тоді беремо дефолти з коду). */
export function useSiteContent() {
  const [data, setData] = useState(cache);
  useEffect(() => {
    listeners.add(setData);
    loadSiteContent();
    return () => { listeners.delete(setData); };
  }, []);
  return data;
}

export function pageMeta(content, path) {
  const def = SITE_PAGES.find((p) => p.path === path) || SITE_PAGES[0];
  const o = content?.pages?.[def.path] || {};
  return { title: o.title || def.title, description: o.description || def.description };
}

export function calcSettings(content) {
  const c = content?.calculator || {};
  const out = { ...CALC_DEFAULTS };
  Object.keys(CALC_DEFAULTS).forEach((k) => { if (typeof c[k] === 'number') out[k] = c[k]; });
  // Тарифна сітка: бекенд віддає вже розв'язану (блок «Ціни» або дефолт).
  out.fee_tiers = Array.isArray(c.fee_tiers) && c.fee_tiers.length
    ? c.fee_tiers
    : BLOCK_DEFAULTS.pricing.tiers.map((t) => ({ from_usd: t.from_usd, pct: t.pct }));
  return out;
}

/** «15–35» — діапазон ставок сітки (одна ставка — просто число). */
export function feeRange(settings) {
  const p = (settings.fee_tiers || []).map((t) => Number(t.pct)).filter((x) => Number.isFinite(x));
  if (!p.length) return fmtNum(settings.trading_fee_pct);
  const lo = Math.min(...p);
  const hi = Math.max(...p);
  return lo === hi ? fmtNum(lo) : `${fmtNum(lo)}–${fmtNum(hi)}`;
}

function feeTiersHtml(settings) {
  const rows = [...(settings.fee_tiers || [])].sort((a, b) => a.from_usd - b.from_usd)
    .map((t) => `<li>від ${fmtNum(t.from_usd)} $ — ${fmtNum(t.pct)}%</li>`);
  return rows.length ? `<ul>${rows.join('')}</ul>` : '';
}

const fmtNum = (v) => Number(v).toLocaleString('uk-UA', { maximumFractionDigits: 2 }).replace(/ /g, ' ');

/** HTML підказки калькулятора: перекриття з адмінки або дефолт, з підстановкою чисел. */
export function calcHelpHtml(content, key) {
  const def = CALC_HELP.find((h) => h.key === key);
  const html = content?.calculator?.help?.[key] || def?.html || '';
  const s = calcSettings(content);
  return sanitizeHtml(html
    .replace(/\{fee_tiers\}/g, feeTiersHtml(s))
    .replace(/\{free_months\}/g, fmtNum(s.free_months))
    .replace(/\{fee_pct\}/g, feeRange(s))
    .replace(/\{threshold\}/g, fmtNum(s.trading_fee_threshold))
    .replace(/\{deposit_fee_pct\}/g, fmtNum(s.deposit_fee_pct))
    .replace(/\{tax_pct\}/g, fmtNum(s.tax_pct)));
}

// Білий список тегів редактора. Решта розгортається в текст, атрибути — лише href.
const ALLOWED = new Set(['P', 'BR', 'B', 'STRONG', 'I', 'EM', 'U', 'UL', 'OL', 'LI', 'A', 'H3', 'H4', 'DIV', 'SPAN']);

export function sanitizeHtml(html) {
  if (!html) return '';
  let doc;
  try { doc = new DOMParser().parseFromString(`<div>${html}</div>`, 'text/html'); } catch (_) { return ''; }
  const walk = (node) => {
    [...node.childNodes].forEach((ch) => {
      if (ch.nodeType === 3) return;
      if (ch.nodeType !== 1 || ['SCRIPT', 'STYLE', 'IFRAME', 'OBJECT', 'EMBED'].includes(ch.tagName)) {
        ch.remove();
        return;
      }
      walk(ch);
      if (!ALLOWED.has(ch.tagName)) {
        ch.replaceWith(...ch.childNodes);
        return;
      }
      [...ch.attributes].forEach((a) => {
        const ok = ch.tagName === 'A' && a.name === 'href' && /^(https?:|mailto:|tel:|\/)/i.test(a.value.trim());
        if (!ok) ch.removeAttribute(a.name);
      });
      if (ch.tagName === 'A') { ch.setAttribute('target', '_blank'); ch.setAttribute('rel', 'noopener noreferrer'); }
    });
  };
  const root = doc.body.firstChild;
  walk(root);
  return root.innerHTML;
}

/** Блок сайту: перекриття з адмінки або дефолт із коду. Поки контент не
 *  завантажено — дефолт (як і для title/description). */
export function blockOf(content, name) {
  const o = content?.blocks?.[name];
  return o && typeof o === 'object' ? { ...BLOCK_DEFAULTS[name], ...o } : BLOCK_DEFAULTS[name];
}

export function useBlock(name) {
  return blockOf(useSiteContent(), name);
}

/** Заявлена дохідність як число для лічильників і формул: «43%+» → {prefix:'', num:43, suffix:'%+'}.
 *  Не розібралось (у полі немає числа) → null, тоді показуємо текст як є. */
export function claimParts(content) {
  const s = String(blockOf(content, 'general').returns_claim ?? '').trim();
  const m = s.match(/^([^\d]*?)(\d+(?:[.,]\d+)?)(.*)$/);
  if (!m) return null;
  const frac = m[2].split(/[.,]/)[1] || '';
  return { text: s, prefix: m[1], num: parseFloat(m[2].replace(',', '.')), decimals: frac.length, suffix: m[3] };
}

export function useClaim() {
  return claimParts(useSiteContent());
}

/** Підстановка спільних чисел ({returns_claim}) у текст блоку. */
export function fillVars(text, content) {
  const g = blockOf(content, 'general');
  return String(text || '').replace(/\{returns_claim\}/g, g.returns_claim);
}

/** Текст із переносами рядків → масив вузлів з <br/>. */
export function lines(text) {
  const parts = String(text || '').split('\n');
  return parts.flatMap((p, i) => (i ? [<br key={i} />, p] : [p]));
}

export const telHref = (phone) => {
  const d = String(phone || '').replace(/[^\d+]/g, '');
  return d ? `tel:${d}` : '';
};
export const telegramHref = (tg) => {
  const s = String(tg || '').trim();
  if (!s) return '';
  if (/^https?:\/\//i.test(s)) return s;
  return `https://t.me/${s.replace(/^@/, '')}`;
};
export const safeHref = (h) => (/^(https?:|mailto:|tel:|\/)/i.test(String(h || '').trim()) ? String(h).trim() : '');
